// @flow

import React from 'react';
import {PrimaryAlternateBtn} from "../../Core/components/Buttons";
import styled from "@emotion/styled";
import {getWindow} from "../../Helpers/browsers";
import {event} from "../../Helpers/ga";
import {APP_NAME} from "../App";

let PrintLayout = styled('div')`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

let PrintButton = styled(PrimaryAlternateBtn)`
  margin: 0;
  background: none;
  
  &:hover, &:focus, &:active {
    background: none;
  }
`;

function print() {
  getWindow().then(window => {
    event(APP_NAME, 'Print Schedule', '');
    window.print();
  })
}

export default function Print() {
  return <PrintLayout>
    <PrintButton onClick={print}>
      <i className="fa-print fas"/> Print Schedule
    </PrintButton>
  </PrintLayout>;
}